import apiClient from './client';
import type { AdminGrowthCharts } from '../types/growthCharts';

/**
 * Client for the admin growth-charts endpoint.
 *
 * One round trip returns every per-day series + the conversion-rate stat
 * block for a single window, so the page can refresh all charts off one
 * `days` change without fanning out into seven concurrent requests.
 *
 * The backend clamps `days` to [1, 730], so any UI selection (including
 * "1 year" / 365) is safe.
 */

export async function getAdminGrowthCharts(
  days: number = 90
): Promise<AdminGrowthCharts> {
  const { data } = await apiClient.get<AdminGrowthCharts>('/admin/growth/', {
    params: { days },
  });
  return data;
}
